export default {
    lang: "zh_tw",
    //登录
    loginIn: '歡迎登錄',
    logout: '退出',
    leaderManage: '集團公司後臺管理',
    phoneormail: '請輸入手機或郵箱',
    mail: '請輸入郵箱',
    phone: '請輸入手機號碼',
    vcode: '請輸入驗證碼',
    rememberaccount: '記住帳號密碼',
    loginSub: '登入',
    sendphonemail: '手機或郵箱必須輸入',
    errorphonemail: '格式有誤',
    phoneRequired: '手機號碼必須輸入',
    mailRequired: '郵箱必須輸入',
    emailLogin: '郵箱登錄',
    phoneLogin: '手機登錄',
    send: '獲取',
    area: '所屬國家',
    selectArea: '請選擇所屬國家',
    visitor: '游客',
    agentMember: '平臺交易會員',
    trader: '平臺交易員',
    changeCancel: '轉取消',
    reload: '請重新加載',
    yz: '亞洲',
    oz: '歐洲',
    fz: '非洲',
    bm: '北美洲',
    nm: '南美洲',
    dy: '大洋洲',
    nj: '南極洲',
    description: '转账账号',
    selectPhoneorEmail: '僅需要輸入手機號碼或郵箱地址其中一種',
    voucher: '交易憑證',
    voucherPreview: '交易憑證預覽',
    transact: '交易方式',
    transactTime: '交易时间',
    reason: '失败原因',
    ruleName: '請輸入2-16的數字或字母組合',

    msg1: '帳戶名必須輸入',
    msg2: '密碼必須輸入',
    msg3: '驗證碼必須輸入',
    msg4: '請先輸入正確的手機或郵箱',
    msg5: '驗證碼發送成功',
    msg6: '當前語言',
    msg7: '當前時區',
    msg8: '請選擇地區號',
    //手动提现
    manual: '手動提現數',
    manual1: '模糊查詢',
    manual2: '請輸入會員/商戶帳號/訂單號',
    manual3: '手動提現',
    manual4: '創建日期',
    manual5: '選定商戶',
    manual6: '選定會員',
    manual7: '請輸入會員名稱',
    manual8: '請選擇支付方式',
    manual9: '支付詳情',
    manual10: '取消訂單',
    manual11: '提交訂單',
    manual12: '請選擇拒絕原因',
    manual13: '故障重審',
    manual14: '請輸入提現金額',
    manual15: '請確認是否提交訂單?',

    //差额值设置
    differenceTitle: '差額值設置',
    differenceValue: '會員利潤差額值',
    differenceTip: '請輸入差額值',
    //提现提成查询
    percentage: '等級',
    percentage1: '總額',
    percentage2: '本時段提成總額',
    percentage3: '本時段提成筆數',
    percentage4: '累計提成總額',
    percentage5: '累計提成筆數',
    percentage6: '精確搜索',
    percentage7: '或',
    percentage8: '提現會員',
    percentage9: '提成額',
    percentage10: '提成時間',
    percentage11: '詳細資訊',
    percentage12: '提成詳情',
    //提现通道列表
    channel: '通道類型',
    channel1: '通道狀態',
    channel2: '線上狀態',
    channel3: '所屬會員',
    channel4: '所屬分公司',
    channel5: '會員狀態',
    channel6: '會員餘額',
    channel7: '通道最小值',
    channel8: '專屬通道',
    channel9: '是',
    channel10: '否',
    channel11: '成功次數',
    channel12: '死碼次數',
    channel13: '通道總數',
    channel14: '開啟總數',
    channel15: '關閉總數',
    //提现订单查询
    withdraw: '本時段提現總額',
    withdraw1: '本時段提現筆數',
    withdraw2: '累計提現總額',
    withdraw3: '累計提現筆數',
    withdraw4: '請輸入帳戶名或訂單號',
    withdraw5: '査詢',
    withdraw6: '會員等級',
    withdraw7: '操作時間',
    withdraw8: '提現詳情',
    withdraw9: '會員提額審批記錄',
    withdraw10: '會員累計提額總額',
    withdraw11: '會員本時段提額總額',
    withdraw12: '請輸入帳戶名或訂單號(包括第三方)',
    //会员提额审批
    limit: '提額額度',
    limit1: '申請提額次數',
    limit2: '提額詳情',
    limit3: '提升額度',
    limit4: '時間',
    limit5: '是否確認通過提額？',
    limit6: '是否確認拒絕提額？',
    //会员管理
    edituser: '帳號:',
    edituser1: '名稱:',
    edituser2: '全部下級（個）',
    edituser3: '所屬公司',
    edituser4: '專屬服務',
    edituser5: '專屬商戶',
    edituser6: '直屬下線',
    edituser7: '直屬下線詳情',
    edituser8: '下線名稱',
    edituser9: '人',
    edituser10: '提現通道資訊',
    edituser11: '二維碼',
    edituser12: '不可操作',
    edituser13: '删除提示',
    edituser14: '是否删除會員',
    edituser15: '及其下級會員',
    edituser16: '删除成功',
    edituser17: '新增專屬服務',
    edituser18: '新增專屬會員',
    edituser19: '新增專屬分公司',
    edituser20: '是否刪除該賬號?',
    //个人中心
    myuser: '基本資訊',
    myuser1: '修改資料',
    myuser2: '完成修改',
    myuser3: '取消修改',
    myuser4: '集團公司帳號',
    myuser5: '集團公司名稱',
    myuser6: '主貨幣',
    myuser7: '電子郵箱',
    myuser8: '下層資訊',
    myuser9: '下級類型',
    myuser10: '數量',
    myuser11: '費率類型',
    myuser12: '費率數值',
    myuser13: '總公司帳號',
    myuser14: '總公司名稱',
    myuser15: '支持貨幣/餘額資訊',
    myuser16: '帳戶總額',
    myuser17: '支持通道/費率資訊',
    myuser18: '額度詳情',
    myuser19: '商戶代理帳號',
    myuser20: '商戶代理名稱',
    myuser21: '客戶流量購買比例',
    myuser22: '流量比例',
    myuser23: '請輸入數字或小數',
    myuser24: '其他貨幣',
    myuser25: '其他提成',
    myuser26: '我的通道',
    myuser27: '費率資訊',
    myuser28: '我的通道',
    myuser29: '提成率',
    myuser30: '其它費率',
    myuser31: '費率值',
    myuser32: '員工賬號',
    myuser33: '員工名稱',
    myuser34: '修改郵箱',
    myuser35: '請再次輸入新的郵箱',
    myuser36: '未設置郵箱，請聯繫集團公司',
    myuser37: '請輸入新的郵箱',
    myuser38: '郵箱輸入不一致',
    myuser39: '修改電話',
    myuser40: '請完善電話信息',

    //员工
    employee1: '員工數量',
    employee2: '請輸入員工帳號',
    employee3: '添加員工',
    employee4: '員工帳號',
    employee5: '員工名稱',
    employee6: '角色類型',
    employee7: '電話號碼',
    employee8: '編輯',
    employee9: '登入帳號',
    employee10: '編輯員工資料',
    employee11: '郵箱地址格式錯誤',
    //银行
    bank: '銀行個數',
    bank1: '添加新銀行',
    bank2: '編號',
    bank3: '銀行本國名稱',
    bank4: '詳細名稱',
    bank5: '類型排序',
    bank6: '添加銀行類型',
    bank7: '修改銀行類型',
    bank8: '請輸入銀行簡稱',
    bank9: '請輸入詳細名稱',
    bank10: '銀行卡個數',
    bank11: '添加新銀行卡',
    bank12: '銀行帳號',
    bank13: '每日限額',
    bank14: '每週限額',
    bank15: '每月限額',
    bank16: '銀行類型',
    bank17: '銀行網點',
    bank18: '確認删除該銀行卡?',
    bank19: '請確認删除?',
    bank20: '添加銀行卡',
    bank21: '修改銀行卡',
    bank22: '請輸入帳號',
    bank23: '國家',
    bank24: '銀行英文名稱',
    bank25: '是否開啓',
    bank26: '最近一次修改人',
    bank27: '無',
    bank28: '獲取失敗，請重試',
    bank29: '未查詢到符合條件的數據，請重新選擇',
    bank30: '請輸入銀行網點信息',
    bank31: '請輸入銀行名稱',
    bank32: '請輸入銀行賬號',
    bank33: '銀行卡支付',
    bank34: '流量控制收款通道',
    bank35: '全球理財收款通道',
    bank36: '廣告推流收款通道',
    bank37: '本幣理財收款通道',
    bank38: '添加收款通道',
    bank39: '修改收款通道',
    bank40: '新增收款通道',
    bank41: '請選擇收款通道類型',
    bank42: '掃碼轉賬',
    bank43: '數字貨幣轉賬',
    bank44: '交易所平臺',
    bank45: '鏈名稱通道',
    bank46: '收款錢包地址',
    bank47: '數字貨幣名稱',
    bank48: '收款郵箱',
    bank49: '掃碼類型',
    bank50: '請輸入交易平臺',
    bank51: '請輸入收款錢包地址',
    bank52: '請選擇收款二維碼',
    bank53: '請輸入收款郵箱',
    bank54: '請輸入收款賬號',
    bank55: '請輸入掃碼類型',
    bank56: '請輸入正確收款錢包地址，必須包含英文字母、數字、冒號',
    bank57: '清除',
    bank58: '轉賬數量',
    bank59: '銀行卡類型',
    bank60: '全球理財',
    bank61: '本幣理財',
    bank62: '廣告推流',
    bank63: '流量控制',
    bank64: '收款銀行地址',
    bank65: '收款銀行所在國家',
    bank66: '收款銀行代碼',
    bank67: '收款人地址',
    bank68: '銀行-國家-分行代碼',
    bank69: '請輸入收款銀行地址',
    bank70: '請輸入收款銀行所在國家',
    bank71: '請輸入收款銀行代碼',
    bank72: '請輸入收款人地址',
    bank73: '銀行卡狀態已開啓，無法修改',
    bank74: '商戶充值收款通道',
    bank75: '轉賬資料未填寫完整',
    bank76: '商戶充值',
    bank77: '掃碼收款賬號',

    //角色
    role: '角色',
    role1: '請輸入角色名字',
    role2: '査詢',
    role3: '新增',
    role4: '角色名字',
    role5: '許可權',
    role6: '新增',
    role7: '角色名字不能為空',
    role8: '選單必須輸入',
    role9: '將删除角色，是否繼續?',
    role10: '角色删除成功',
    role11: '將删除所選角色，是否繼續?',
    //菜单
    menu: '選單',
    menu1: '請輸入選單名字',
    menu2: '標題',
    menu3: '路徑',
    menu4: '圖標',
    menu5: '順序',
    menu6: '啟用',
    menu7: '設定時顯示',
    menu8: '子功能表',
    menu9: '添加',
    menu10: '集團公司',
    menu11: '分公司',
    menu12: '商代',
    menu13: '總公司',
    menu14: '添加子功能表',
    menu15: '標題不能為空',
    menu16: '路徑不能為空',
    menu17: '圖標不能為空',
    menu18: '修改子功能表',
    menu19: '將删除所選選單，是否繼續?',
    menu20: '選單删除成功',
    menu21: '名稱',
    menu22: '時',
    menu23: '刷新',
    menu24: '全踢出',
    menu25: '分',
    menu26: '登入時間',
    menu27: '在綫時間',
    menu28: '登入IP/歸屬地',
    menu29: '登入方式/來源',
    menu30: '秒',
    menu31: '天',
    menu32: '踢出',
    menu33: '是否下線該用戶?',
    menu34: '操作成功',
    menu35: '是否下線全部用戶?',

    //兑换
    exchange: '是否啟用現金支付兌換功能？',
    exchange1: '啟用',
    exchange2: '不啟用',
    exchange3: '(下級將無法使用)',
    exchange4: '未開啟任何貨幣',
    exchange5: '洲際選擇',
    exchange6: '已選國家',
    exchange7: '展開選擇',
    exchange8: '省份選擇',
    exchange9: '市級選擇',
    exchange10: '（點擊選擇）',
    exchange11: '國家清單',
    exchange12: '省份清單',
    exchange13: '批量開啟/單選下級',
    exchange14: '點擊選擇',
    exchange15: '點擊重選',
    exchange16: '是否啟用籌碼支付兌換功能？',
    exchange17: '會所選擇',
    exchange18: '新增會所',
    exchange19: '會所名稱',
    exchange20: '會所狀態',
    exchange21: '請輸入會所名稱',
    exchange22: '您確認要删除該會所嗎?',
    exchange23: '删除確認',
    exchange24: '是否啟用數位支付兌換功能？',
    exchange25: '數位貨幣',
    exchange26: '新增平臺',
    exchange27: '平臺名稱',
    exchange28: '已添加數位貨幣',
    exchange29: '請輸入平臺名稱',
    exchange30: '請選擇數位貨幣',
    exchange31: '您確認要删除該平臺嗎?',
    exchange32: '城市列表',
    exchange33: '等值',
    exchange34: 'USD以下形成派單',
    exchange35: '平臺代理會員',
    exchange36: '所選城市現有',
    exchange37: '位平臺代理會員',
    exchange38: '所選城市不存在平臺代理會員',
    //货币汇率
    currency1: '法定貨幣個數',
    currency2: '數位貨幣個數',
    currency3: '請輸入貨幣名稱',
    currency4: '添加貨幣',
    currency5: '貨幣程式碼',
    currency6: '國家名稱',
    currency7: '相對匯率',
    currency8: '貨幣程式碼',
    currency9: '主貨幣',
    currency10: '修改完本頁請先保存，再進行下一頁操作',
    currency11: '新增法定貨幣',
    currency12: '修改法定貨幣',
    currency13: '請輸入貨幣程式碼',
    currency14: '請輸入國家名稱',
    currency15: '確認删除該貨幣?',
    currency16: '請確認删除?',
    currency17: '添加數位貨幣',
    currency18: '貨幣名稱',
    currency19: '新增數位貨幣',
    currency20: '修改數位貨幣',
    currency21: '貨幣符號',
    currency22: '法定貨幣',

    loading: '加載中...',
    WECHAT_PAY: '微信掃碼',
    ALI_PAY: '支付寶掃碼',
    CREDIT_PAY: '微信點贊碼',
    PERSONAL_BANK_PAY: '個人銀行轉帳',
    ENTERPRISE_BANK_PAY: '企業銀行轉帳',
    CLOUD_FLASH_PAY: '雲閃付支付',
    PAYPAL_PAY: 'PayPal',
    ZALO_PAY: 'Zalo Pay',
    UPI_PAY: 'Upi',
    MER_UNMATCH: '匹配失敗',
    BANK_PAY: '銀行轉帳',
    SCAN_PAY: '掃碼提現',
    MER_PENDING: '處理中',
    MER_SUCCESS: '已完成',
    MER_CANCEL: '取消單',
    MER_FAULT: '故障單',
    MER_FAULTDONE: '故障完成',
    MER_PROCESS: '待支付',
    MER_RETRIAL: '已重審',
    ALL: '全部',
    SOLD: '已賣出',
    WAITING: '待處理',
    SUCCESS: '已完成',
    REJECTED: '已拒絕',
    BEARING: '計息中',
    FREEZE: "凍結中",
    vip: '會員',
    vvip: '高級會員',
    l1: '一級會員',
    l2: '二級會員',
    l3: '三級會員',
    BRANCHROBING: '分公司搶單中',
    FAULT: '故障單',
    FAULTDONE: '故障已完成',
    company: '分公司',
    merchant: '商戶',
    merchantAgent: '商戶代理',
    employee: '員工',
    companyAgent: '總公司',
    enable: '開啟',
    disable: '關閉',
    FREEZE_WAITING: '凍結待審批',
    FREEZE_SUCCESS: '凍結成功',
    FREEZE_REJECTED: '凍結拒絕',
    UNFREEZE_SUCCESS: '解凍成功',
    UNFREEZE_WAITING: '解凍待審批',
    VIPROBING: '會員搶單中',
    VIPPAYING: '會員付款中',
    fddh: '貨幣兌換率',
    wtdh: '委託兌換率',
    hkdh: '匯款兌換率',
    qqlc: '對沖貨幣理財',
    xylc: '幸運理財',
    lcze: '理財總額',
    djje: '凍結金額',
    interest: '公司派息',
    register: '注冊',
    globalBonus: '對沖貨幣理財',
    remittanceFault: '匯款故障',
    financial: '幸運理財',
    payorderMER_PROCESS: '處理中',
    bonus: '提現提成',
    payorderMER_FAULTDONE: '故障完成單',
    payorderMER_CANCEL: '取消單',
    payorderautoMER_CANCEL: '超時自動取消',
    DEPOSITSUCCESS: '普通上分',
    legal: '貨幣兌換',
    remittance: '匯款',
    luckBonus: '幸運理財',
    entrust: '委託兌換',
    depositRemittance: '公司搶單充值',
    payorderMER_RETRIAL: '重審',
    payorderMER_SUCCESS: '成功',
    commission: '手續費',
    saleFinance: '賣出理財',
    WITHDRAWWAITING: '提現',
    REMITTANCE: '匯款',
    entrustWAITING: '委託兌換',
    startPlaceholder: '開始日期',
    endPlaceholder: '結束日期',
    ConditionalScreening: '條件篩選',
    FindDate: '查找日期',
    CurrencyType: '貨幣類型',
    BaseCurrency: '主貨幣',
    PleaseSelect: '請選擇',
    currency: '貨幣',
    Rate: '匯率',
    WithdrawalOrderNo: '提現訂單號',
    WithdrawalBank: '提現銀行',
    WithdrawalScore: '提現金額',
    WithdrawalAmount: '提現分額',
    Amount: '金額',
    ApplicationDate: '申請日期',
    Operation: '操作',
    Details: '詳情',
    WithdrawalCurrency: '提現貨幣',
    BankAccount: '銀行帳戶',
    BankCardNumber: '銀行卡號',
    BankName: '銀行名稱',
    NameOfPayBank: '支付銀行',
    VerificationCode: '驗證碼',
    Close: '關閉',
    Submit: '提交',
    Remarks: '備註',
    ApplicationTime: '申請時間',
    Reviewer: '稽核人',
    AuditTime: '稽核時間',
    CaptchaInformation: '驗證碼已發送，請注意查收',
    SubmitSuccess: '提交成功',
    addCompany: '添加分公司',
    Information: '資料資訊',
    BranchAccount: '分公司帳號',
    LoginPassword: '登入密碼',
    BranchName: '分公司名稱',
    WithdrawalChannelControl: '提現通道控制',
    CurrencyTypes: '外幣開關設定',
    RoyaltyRate: '提成率',
    ReviseSucceed: '修改成功',
    ReviseFail: '修改失敗',
    Revise: '修改',
    globalFinancial: '對沖貨幣理財',
    commonFinancial: '普通理财',
    setAvatar: '設置頭像',
    avatarSetted: '頭像設置成功',
    avatarSettedError: '頭像設置失敗',
    chooseAgain: '請重新選擇',
    freezeName: '申請人',

    selectImage: '選 擇 圖 片',
    avatarPreview: '頭 像 預 覽',
    updateimage: '更 換 圖 片',
    imageTips: '圖片不可大於',
    imageTypeTip: '圖片類型必須是',
    imageTypeTip2: '中的壹種',
    selectBank: '請選擇銀行',
    deleteSucced: '刪除成功',
    deleteFail: '刪除失敗',
    matchCur: '匹配貨幣',
    setUp: '設置',
    drainagePersonName: '引流人',

    movie: {
        selectMovieUp: '選擇電影上傳',
        updateMovie: '編輯電影',
        upTipTitle: '溫馨提醒',
        upTip1: '1.請勿上傳色情或者違法反動視頻',
        upTip2: '2.請使用星際網上上傳視頻，表示默認同意我們的',
        movieAgreement: '內容協議',
        movieOver: '封面',
        updateOver: '修改封面',
        fileName: '文件名',
        recommendedArea: '推薦區',
        movieDistrict: '影視區',
        fontCount: '字數：5-100字',
        upMovieSuccess: '視頻上傳成功！正在轉碼.....',
        movieMsgTitle: '您剛上傳視頻信息',
        movieOverImg: '預覽圖',
        movieTitle: '標題',
        movieTag: '標語',
        movieType: '分類',
        movieAddress: '位置',
        movieIntroduction: '簡介',
        movieUp: '繼續上傳',
        againUp: '重新上傳',
        release: '發布'

    },


    addMer: {
        nextStep: '下一步',
        back: '上一步',
        addtitle: '添加商戶資料',
        addBranchAgentTitle: '新增總公司',
        addMerchantAgentTitle: '添加商戶代理資料',
        uptitle: '修改商戶資料',
        shtitle: '審核商戶資料',
        titleDetail: '商戶資料詳情',
        agentAccount: '代理帳號',
        agentName: '代理名稱',
        dataSettings: '資料設定',
        channelSettings: '通道設定',
        rateSettings: '費率設定',
        merchantType: '商戶類型',
        merchantAccount: '商戶帳號',
        currencyType: '貨幣類型',
        password: '登入密碼',
        merchantName: '商戶名稱',
        phone: '聯繫電話',
        accountLimit: '帳戶額度',
        email: '郵箱地址',
        domainName: '域名',
        role: '角色權限',
        key: '密鑰',
        platformInfo: '平臺信息',
        largestSingleGold: '入金單筆最大',
        merchantKey: '商戶密鑰',

        WechatCode: '微信掃碼',
        AlipayCode: '支付寶掃碼',
        wechatLikeCode: '微信讚賞碼',
        PersonalBankTransfer: '個人銀行轉帳',
        CorporateBankTransfer: '企業銀行轉帳',

        wechatPayment: '微信支付',
        alipayPayment: '支付寶支付',
        bankpayment: '銀行支付',
        cloudPayment: '雲閃付支付',
        personalBank: '個人銀行',
        corporateBank: '企業銀行',
        scanPayment: '掃碼支付',

        open: '開啟',
        close: '關閉',
        currencyTypes: '外幣開關設定',
        optionalCurrency: '可選擇貨幣',
        OptionalCurrencys: '可選貨幣',
        opened: '已開啟',
        openedCurrency: '已開啟貨幣',
        depositServiceRate: '提現提成率',
        rujinServiceRate: '入金手續費率',
        dailiServiceRate: '代理手續費率',
        dailiOtherRate: '代理其他费率',
        agencyRate: '我的提成率',
        myRate: '我的費率',
        profitRate: '我的盈利率',
        otherRate: '其他費率',
        statutoryExchange: '貨幣兌換',
        entrustedExchange: '委託兌換',
        remittance: '匯款',
        remittanceExchange: '匯款',
        luckFinancing: '幸運理財',
        globalFinancing: '對沖貨幣理財',
        myHandRate: '我的手續費率',
        myOtherRate: '我的其他費率',
        remittanceServe: '匯款服務費',

        luckFinancingRate: '幸運理財收益率',
        globalFinanceRate: '對沖貨幣理財收益率',
        LegalCurrencyExchange: '貨幣兌換',
        EntrustedOrderExchange: '委託兌換',
        RemittanceServiceRate: '匯款手續費率',
        legal: '法币兑法币',
        legalDigit: '法币兑数币',
        digit: '数币兑数币',
        digitLegal: '数币兑法币',

        cancel: '取 消',
        determine1: '確 定',
        prevPage: '上一頁',
        nextPage: '下一頁',
        adopt: '通 過',
        refuse: '拒 絕',
        merchant: '商戶',
        vvip: '高級會員',

        checkBranchAccount: '請輸入總公司帳號',
        checkBranchType: '請選擇分公司類型',
        checkBranchName: '請輸入分公司名稱',
        checkBranchComAgent: '請輸入總公司名稱',

        checkAccount: '請輸入商戶帳號',
        checkPassword: '請輸入密碼',
        checkName: '請輸入商戶名稱',
        checkphone: '請輸入聯繫電話',
        checkAccountLimit: '請輸入帳戶額度',
        checkEmail: '請輸入郵箱地址',
        checkTrueEmail: '請輸入正確的郵箱地址',
        checkUserType: '請選擇商戶類型',
        checkCurrId: '請選擇貨幣類型',
        checkRole: '請選擇角色權限',

        EmailError: '郵箱格式錯誤',
        LuckRateError: '請設定正確的幸運理財收益率',
        legalRateError: '請設定正確的法定貨幣兌換率',
        EntrustRateError: '請設定正確的委託指令兌換率',
        RemittanceRateError: '請設定正確的匯款手續匯率',

        whether: '是否',
        passageway: '通道',
        passageways: '通道資訊',
        Tips: '提示',
        determine: '確定',
        cancel1: '取消',
        statusUpSuccess: '狀態更新成功',
        statusUpFail: '狀態更新失敗',
        account: '帳戶',
        openCurrencyCheck: '是否開啟當前貨幣?',
        closeCurrencyCheck: '是否關閉當前貨幣?',
        openSuccessfully: '開啟成功',
        closeSuccessfully: '關閉成功',
        confirmationApproval: '確認通過審批',
        rejectionApproval: '確認拒絕審批',
        checkPass: '審批確認',
        approved: '審批已通過',
        rejected: '審批已拒絕',
        addSuccess: '添加成功',
    },

    approvalList1: '待審批商戶',
    approvalList2: '商戶代理',
    approvalList3: '已審批商戶',
    approvalList4: '條件篩選',
    approvalList5: '用戶類型',
    approvalList6: '全部',
    approvalList7: '高級會員',
    approvalList8: '商戶',
    approvalList9: '分公司',
    approvalList11: '請選擇',
    approvalList10: '貨幣類型',
    approvalList12: '請輸入用戶名',
    approvalList13: '用戶帳號',
    approvalList14: '用戶名稱',
    approvalList15: '用戶類型',
    approvalList16: '代理名稱',
    approvalList17: '用戶貨幣',
    approvalList18: '其他幣種',
    approvalList19: '聯繫方式',
    approvalList20: '審批時間',
    approvalList21: '申請時間',
    approvalList22: '完成時間',
    approvalList23: '審批狀態',
    approvalList24: '已完成',
    approvalList25: '已拒絕',
    approvalList26: '待審批',
    approvalList27: '審核商戶代理資料',
    approvalList28: '資料資訊',
    approvalList29: '通道設定',
    approvalList30: '費率設定',
    approvalList31: '確認關閉',
    approvalUpCom1: '上級帳號',
    approvalUpCom2: '分公司帳號',
    approvalUpCom3: '帳號額度',
    approvalUpCom4: '貨幣類型',
    approvalUpCom5: '分公司名稱',
    approvalUpCom6: '聯繫電話',
    approvalUpCom7: '郵箱',
    approvalUpCom8: '域名',
    approvalUpCom9: '登入密碼',
    approvalUpCom10: '角色權限',
    approvalUpCom11: '外幣開關設定',
    approvalUpCom12: '已開啟貨幣',
    approvalUpCom13: '可選擇貨幣',
    approvalUpCom14: '已開啟',
    guanbi: '關閉',
    kaiqi: '開啟',
    approvalUpCom15: '提成率',
    approvalUpCom16: '代理費率',
    approvalUpCom17: '微信掃碼',
    approvalUpCom18: '支付寶掃碼',
    approvalUpCom19: '微信點贊碼',
    approvalUpCom20: '個人銀行轉帳',
    approvalUpCom21: '企業銀行轉帳',
    approvalUpCom22: '雲閃付支付',
    approvalUpCom23: '其他費率',
    approvalUpCom24: '貨幣兌換',
    approvalUpCom25: '委託兌換',
    approvalUpCom26: '匯款手續費率',
    approvalUpCom27: '幸運理財收益率',

    tongguo: '通過',
    jujue: '拒絕',
    approvalUpCom28: '請選擇角色權限',
    approvalUpCom29: '確認通過審批？',
    approvalUpCom30: '審批確認',
    queding: '確定',
    quxiao: '取消',
    approvalUpCom31: '審批通過',
    approvalUpCom32: '審批失敗',
    approvalUpCom33: '確認拒絕審批？',
    approvalUpCom34: '審批拒絕',
    approvalUpCom35: '成功',
    approvalUpCom36: '狀態更新成功',
    approvalUpCom37: '關閉成功',
    approvalUpCom38: '開啟成功',
    approvalUpCom39: '對沖貨幣理財收益率',
    approvalUpCom40: '修改總公司資料',
    approvalUpCom41: '代理提成率',
    approvalUpCom42: '審核商戶資料',
    approvalUpCom43: '查看分公司資料',
    approvalUpCom44: '查看商戶資料',

    applyList1: '待審批商戶',
    applyList2: '已審批商戶',
    applyList3: '待審批商戶代理',
    applyList4: '已審批商戶代理',
    applyList5: '條件篩選',
    applyList6: '商戶類型',
    applyList7: '請選擇',
    applyList8: '全部',
    applyList9: '高級會員',
    applyList34: '商戶',
    applyList10: '貨幣類型',
    applyList11: '請輸入用戶名',
    applyList12: '添加新商戶',
    applyList13: '添加新分公司',
    applyList14: '商戶帳號',
    applyList15: '商戶名稱',
    applyList16: '商戶類型',
    applyList17: '分公司帳號',
    applyList18: '分公司名稱',
    applyList19: '貨幣',
    applyList20: '其他幣種',
    applyList21: '聯繫方式',
    applyList22: '創建時間',
    applyList23: '審批狀態',
    applyList33: '操作',
    applyList24: '已完成',
    applyList25: '處理中',
    applyList26: '已拒絕',
    applyList27: '詳情',
    applyList28: '修改總公司資料',
    applyList29: '資料資訊',
    applyList30: '通道設定',
    applyList31: '費率設定',
    applyList32: '確認關閉？',

    withdrawManage1: '商戶提現申請表',
    withdrawManage2: '商戶累計提現總額',
    withdrawManage3: '商戶本時段提現總額',
    withdrawManage4: '審核狀態',
    withdrawManage5: '開戶行',
    withdrawManage6: '清空',
    withdrawManage7: '提額分額',
    withdrawManage8: '備註資訊',
    withdrawManage9: '電話/郵箱',
    withdrawManage10: '登錄名',
    withdrawManage11: '提現分數',
    withdrawManage12: '提現前餘分',
    withdrawManage13: '累計提現',
    withdrawManage14: '拒絕原因',
    withdrawManage15: '提現申請表',
    withdrawManage16: '累計提現總額',
    withdrawManage17: '本時段提現總額',

    agentList1: '全部代理',
    agentList2: '接入數量最多',
    agentList3: '接入商戶最多',
    agentList4: '總盈利最高',
    agentList5: '請輸入代理名',
    agentList6: '總盈利',
    agentList7: '盈利',
    agentList8: '接入數',
    agentList9: '分公司管理',
    OpenState: '開啟狀態',
    AgentType: '代理類型',
    OtherCurrency: '其他幣種',
    AccountBalance: '帳戶餘額',
    BalanceDetails: '餘額詳情',
    CurrencyHeld: '持有幣種',
    Balance: '餘額',
    FinancialDetails: '理財詳情',
    State: '狀態',
    SuperiorAccount: '上級名稱',
    Unbound: '未綁定',
    Complete: '完成',
    ChannelCategory: '通道類別',
    CommissionRate: '手續費率',

    settlement1: '代理提現審批記錄',
    settlement2: '代理累計提現總額',
    settlement3: '代理當日提現總額',
    settlement4: '提現代理帳戶',
    settlement5: '已審批',
    settlement6: '未審批',
    settlement7: '修改代理資料',
    settlement8: '修改商戶代理資料',
    PlsAccount: '請輸入帳戶名',
    Export: '導出',
    CurrentState: '當前狀態',
    TransactionNO: '交易單號',
    WithdrawalAccount: '提現帳戶',
    WithdrawalName: '提現名稱',
    UpperScore: '上分',
    Remainder: '餘分',
    CheckReject: '拒絕確認',
    RejectReason: '請輸入拒絕原因',
    Input30Max: '最多輸入30字',
    RejectedSuccessfully: '拒絕成功',
    ThroughSuccess: '通過成功',
    ThroughConfirmation: '通過確認',
    title1: '新增分公司',
    title2: '分公司理財審批記錄',
    title3: '分公司幸運充值記錄',
    title4: '分公司累計理財總額',
    title5: '分公司當天理財總額',


    company1: '分公司個數',
    company2: '理財總額最高',
    company3: '提現總額最高',
    company4: '下線最多',
    company5: '分公司狀態',
    company6: '所有下線',
    company7: '銀行卡',
    company8: '修改分公司資料',
    company9: '銀行卡信息',
    company10: '賬號類別',
    company11: '賬戶名稱',
    company12: '戶名',
    company13: '卡號',
    company14: '通道開關',
    company15: '是否開啟通道?',
    company16: '是否關閉通道?',
    company17: '交易單號',
    company18: '賬戶名',
    company19: '分公司賬戶名',
    company20: '充值銀行',
    company21: '充值金額',
    company22: '兌換匯率',
    company23: '充值分數',
    company24: '充值當前賬戶餘額',
    company25: '分公司充值审核',
    company26: '貨幣(匯率)',
    company27: '收款銀行名稱',
    company28: '收款銀行卡號',
    company29: '收款銀行賬戶',
    company30: '充值前賬戶餘額',
    company31: '提現申請',
    company32: '選擇貨幣',
    company33: '請選擇貨幣',
    company34: '存款金額',
    company35: '充值分額',
    company36: '收款賬戶',
    company37: '充值確認',
    company38: '上分成功',
    company39: '操作成功，請等待處理',
    company40: '搶單單號',
    company41: '搶單',
    company42: '搶單詳情',
    company43: '開戶銀行',
    company44: '交易截圖',
    company45: '放棄',
    company46: '訂單超時',
    company47: '搶單成功，請等待處理',
    company48: '本幣理財',
    company49: '外幣理財',
    company50: '獎勵金額',
    company51: '總公司提成率',
    company52: '總公司其他費率',
    company53: '搶單會員',

    deposit1: '本時段入金手續費總額',
    deposit2: '本時段入金筆數',
    deposit3: '累計入金手續費總額',
    deposit4: '累計入金筆數',
    deposit5: '請輸入用戶名或訂單號',
    deposit6: '入金金額',
    deposit7: '手續費金額',
    deposit8: '收款時間',
    deposit9: '交易狀態',
    deposit10: '故障單號',
    deposit11: '處理金額',
    deposit12: '故障單詳情',
    deposit13: '收款金額',
    deposit14: '截圖',
    deposit15: '實際金額',
    deposit16: '請輸入實際金額',
    deposit17: '處理完成',
    deposit18: '重審完成',
    deposit19: '凍結資金總額',
    deposit20: '凍結資金筆數',
    deposit21: '訂單號查詢',
    deposit22: '新增凍結',
    deposit23: '申請人',
    deposit24: '凍結申請人',
    deposit25: '解凍申請人',
    deposit26: '凍結審核人',
    deposit27: '解凍審核人',
    deposit28: '凍結時間',
    deposit29: '解凍時間',
    deposit30: '凍結狀態',
    deposit31: '凍結通過',
    deposit32: '凍結拒絕',
    deposit33: '申請解凍',
    deposit34: '解凍成功',
    deposit35: '解凍拒絕',
    deposit36: '新增凍結資金',
    deposit37: '申請',
    deposit38: '凍結確認',
    deposit39: '解凍確認',
    deposit40: '申請成功',
    deposit41: '本時段入金總額',
    deposit42: '累計入金總額',
    deposit43: '入金匯率',
    deposit44: '入金時間',
    deposit45: '激活',
    deposit46: '催單',
    deposit47: '收款貨幣',
    deposit48: '收款方式',
    deposit49: '收款賬號',
    deposit50: '收款二維碼',
    deposit51: '失敗原因',
    deposit52: '收款銀行',
    deposit53: '收款卡號',
    deposit54: '處理時間',
    deposit55: '激活成功',
    deposit57: '催單成功',
    deposit56: '激活確認',
    deposit58: '催單確認',
    deposit59: '入金貨幣',

    deposit60: '入金賬號',
    deposit61: '入金分額',
    deposit62: '入金二維碼',
    deposit63: '入金銀行',
    deposit64: '入金卡號',

    deposit65: '本時段充值總金額',
    deposit66: '本時段充值筆數',
    deposit67: '累計充值總額',
    deposit68: '累計充值筆數',
    deposit69: '充值方式',
    deposit70: '充值費率',
    deposit71: '充值時間',
    deposit72: '充值份額',
    deposit73: '充值賬號',
    deposit74: '充值二維碼',
    deposit75: '充值卡號',
    deposit76: '本時段充值手續費總額',
    deposit77: '累計充值手續費總額',
    deposit78: '接口日志',


    exchane1: '新增兌換',
    exchane2: '貨幣餘額詳情',
    exchane3: '兌出詳情',
    exchane4: '兌出貨幣',
    exchane5: '兌得貨幣',
    exchane6: '兌出金額',
    exchane7: '兌得信息',
    exchane8: '兌換利率',
    exchane9: '兌得金額',
    exchane10: '區域選擇',
    exchane11: '選擇洲際',
    exchane12: '選擇國家',
    exchane13: '選擇省份',
    exchane14: '選擇城市',
    exchane15: '金額幣種',
    exchane16: '當前選擇',
    exchane17: '區域',
    exchane18: '收款人聯繫方式',
    exchane19: '收款人證件資料',
    exchane20: '密碼驗證',
    exchane21: '手機號或郵箱',
    exchane22: '點擊獲取',
    exchane23: '平台貨幣',
    exchane24: '平台賬號',
    exchane25: '本時段兌換總額',
    exchane26: '本時段兌換手續費總額',
    exchane27: '本時段兌換次數',
    exchane28: '累計兌換總額',
    exchane29: '累計兌換手續費總額',
    exchane30: '累計兌換次數',
    exchane31: '累計兌換次數',
    exchane32: '累計兌換訂單號',
    exchane33: '兌換方式',
    exchane34: '兑换金额',
    exchane35: '手續金額',
    exchane36: '兌換時間',
    exchane37: '兌換日期',
    exchane38: '兌換貨幣',
    exchane39: '兌換數字貨幣',
    exchane40: '兌換籌碼',
    exchane41: '收款人選擇區域平台',
    exchane42: '收款人選擇區域',
    exchane43: '兌得數字貨幣金額',
    exchane44: '收款人平台賬號',
    exchane45: '自己',
    exchane46: '是否拒絕?',
    exchane47: '精密搜索',
    exchane48: '或',
    exchane49: '兌換訂單號',
    exchane50: '兌換詳情',
    exchane51: '錢包地址',
    exchane52: '協議',
    exchane53: '二維碼',

    onLine: '在線',
    offLine: '離線',
    VipManagement: '會員管理',
    shanchu: '删除',
    UpdateVipDetail: '修改會員資料',
    CashExchange: '現金支付兌換',
    ChipExchange: '籌碼支付兌換',
    NumberExchange: '數字貨幣兌換',
    pls1: '請輸入訂單號',
    pls2: '請輸入故障訂單號',
    pls3: '請輸入提現單號',
    pls4: '請輸入故障原因',
    pls5: '請選擇兌換類型',
    pls6: '請選擇兌出貨幣',
    pls7: '兌出貨幣不能和兌得貨幣相同',
    pls8: '請選擇兌得貨幣',
    pls9: '兌得貨幣不能和兌出貨幣相同',
    pls10: '請選擇區域',
    pls11: '請選擇省份',
    pls12: '請選擇城市',
    pls13: '該貨幣餘額不足，請重新輸入',
    pls14: '請選擇會所',
    pls15: '請選擇平台',
    pls16: '信息有誤，請檢查',
    pls17: '請輸入訂單號、用戶賬號',

    UserName: '用戶名稱',
    loglout: '退出',
    PaymentMethod: '支付方式',
    OrderAmount: '訂單金額',
    vipType: '會員類型',
    Handle: '處理',
    Retrial: '處理',
    vipAccount: '會員賬號',
    vipName: '會員名稱',
    Declare: '申報',
    FaultReason: '故障申報原因',
    FaultImg: '故障截圖',
    FaultImgDetail: '截圖詳情',
    WithdrawalNo: '提現單號',
    WithdrawalType: '提現方式',
    Handler: '處理人',
    Date: '日期',
    addFault: '新增故障單',
    FaultOrder: '故障訂單號',
    OrderStatus: '訂單狀態',
    OldOrder: '原訂單號',
    UserAccount: '用戶賬號',
    OrderNo: '訂單號',
    CustomerType: '用戶類型',
    DepositMethod: '入金方式',
    UserNickname: '用戶暱稱',
    companyNickName: '分公司名稱',
    ThematicCurrency: '主位幣',
    UsableCurrency: '可用外幣',
    Subsuperior: '所屬上級',
    TotalFinancial: '理財總額',
    TotalWithdrawal: '提現總額',
    NewApply: '新增申請',
    NewWithDraw: '新增提現',
    ViewDetails: '查看詳情',
    LoadingPaymentData: '加載支付資料',
    Loaded: '已加載成功',
    checkAmount: '請輸入正確金額',
    PayeeAccount: '收款人賬號',
    PayeeName: '收款人名稱',
    MaxFiles5: '最多選擇5個文件',
    MaxFiles1: '最多選擇1個文件',
    UploadSuccessful: '上傳成功',
    UploadFailed: '上傳失敗，請檢查網絡',

    product1: '新建產品',
    product2: '修改產品',
    product3: '產品名稱',
    product4: '產品貨幣',
    product5: '回報週期',
    product6: '可購買會員',
    product7: '起投金額',
    product8: '年化計算率',
    product9: '一日收益',
    product10: '三日收益',
    product11: '七日收益',
    product12: '請選擇回報週期',
    product13: '請輸入產品名稱',
    product14: '累計派息總額',
    product15: '當前計息理財總額',
    product16: '請輸入訂單號、產品編號或用戶賬號',
    product17: '產品編號',
    product18: '購買數量',
    product19: '產品週期',
    product20: '累計計息',
    product21: '賣出',
    product22: '時間',
    product23: '計息',
    product24: '賣出確認',
    product25: '賣出成功',
    product26: '產品個數',
    product27: '購買次數最多',
    product28: '請輸入產品編號或產品名稱',
    product29: '創建人',
    product30: '天',
    product31: '購買次數',
    product32: '理財產品購買審核記錄',
    product33: '累計計息理財總額',
    product34: '年化率',
    product35: '新增對沖貨幣理財',
    product36: '修改時間',
    product37: '產品類型',
    product38: '商戶理財',
    product39: '對沖貨幣理財',
    product40: '新增理財產品',
    product41: '商戶理財產品',
    product42: '購買最大值',
    companyFinancial: '总公司理財',
    product43: '可以使用分公司',
    product44: '轉換金額',
    product45: '合計金額',
    product46: '手續金額',
    product47: '集團理財產品',
    product48: '7天',
    product49: '30天',
    product50: '60天',
    product51: '90天',
    product52: '活期',
    product53: '計息中不可以刪除',

    merchant1: '商戶流量購買審批記錄',
    merchant2: '商戶累計購買流量總額',
    merchant3: '商戶本時段購買流量總額',
    merchant4: '購買流量前額度',
    merchant5: '購買流量額度',
    merchant6: '現有賬戶流量',
    merchant7: '提額成功',
    merchant8: '專屬會員',
    merchant9: '請輸入要添加的專屬會員名稱',
    merchant10: '增加',
    merchant11: '序號',
    merchant12: '查看',
    merchant13: '專屬會員詳情',
    merchant14: '添加時間',
    merchant15: '服務筆數',
    merchant16: '服務總額',
    merchant17: '專屬通道開關',
    merchant18: '您確認要刪除會員',
    merchant19: '是否增加新專屬會員',
    merchant20: '商戶個數',
    merchant21: '入金金額最高',
    merchant22: '匯款兌換總額最高',
    merchant23: '聯繫方式',
    merchant24: '購買次數',
    merchant25: '提額詳情',
    merchant26: '提升額度',
    merchant27: '是否確認通過提額',
    merchant28: '是否確認拒絕提額',
    merchant29: '商戶提現審批記錄',
    merchant30: '商戶累計提現總額',
    merchant31: '本時段商戶提現總額',
    merchant32: '購買流量金額',
    merchant33: '流量購買比例',
    merchant34: '購買詳情',
    merchant35: '流量貨幣',
    merchant36: '專屬分公司',
    merchant37: '請輸入要添加的專屬分公司名稱',
    merchant38: '專屬會員通道',
    merchant39: '專屬分公司詳情',
    merchant40: '專屬分公司通道',
    merchant41: '請輸入要添加的專屬分公司名稱',
    merchant42: '是否新增新專屬分公司',
    merchant43: '您確認要删除分公司',
    merchant44: '請輸入購買支付貨幣',
    merchant45: '購買支付貨幣',
    merchant46: '請輸入購買流量額度',
    merchant47: '購買流量額度需大於1000',
    merchant48: '展開設置',
    merchant49: '是否添加旗下所有會員?',
    merchant50: '流量餘額',
    merchant51: '所屬商代',
    merchant52: '所屬總公司',
    merchant53: '查詢所屬上級',

    DelSuccess: '删除成功',
    remit1: '本時段匯款總額',
    remit2: '累計匯款總額',
    remit3: '累計匯款次數',
    remit4: '匯款單號',
    remit5: '匯款信息',
    remit6: '匯款金額',
    remit7: '匯款分額',
    remit8: '確認收款',
    remit9: '詳細匯款資料',
    remit10: '帳號',
    remit11: '匯款前餘額',
    remit12: '累計匯款',
    remit13: '收款銀行',
    remit14: '收款戶名',
    remit15: '收款帳號',
    remit16: '取款貨幣',
    remit17: '貨幣餘額',
    remit18: '銀行網點',
    remit19: '下分分數',
    remit20: '匯款手續費率',
    remit21: '手機郵箱驗證',
    remit22: '請輸入手機號或者郵箱',
    remit23: '請輸入驗證碼',
    remit24: '成功',
    remit25: '收款成功',
    remit26: '重新獲取',
    remit27: '秒重試',
    remit28: '發送成功,該信息有可能被攔截，請仔細查看',
    remit29: '請輸入收款銀行',
    remit30: '請輸入收款賬號',
    remit31: '請輸入收款卡號',
    remit32: '請輸入正確的下分分數',
    remit33: '匯款人名稱',
    remit34: '匯款人賬號',
    remit35: '新增匯款',
    remit36: '匯款貨幣',
    remit37: '匯款分額',
    remit38: '實際匯款金額',
    remit39: '匯出分額',

    OperationMode: '操作方式',
    report1: '本時段提成總額',
    report2: '本時段費率支出總額',
    report3: '本時段操作筆數',
    report4: '累計提成總額',
    report5: '累計費率支出總額',
    report6: '累計操作筆數',
    report7: '精確查找',
    report8: '請輸入訂單號、名稱',
    report9: '客戶名稱',
    report10: '商戶入金',
    report11: '會員提現',
    report12: '訂單時間',
    report13: '代理客戶交易總額',
    report14: '代理客戶費率盈虧總額',
    report15: '代理客戶交易筆數',
    report16: '請輸入訂單號、賬號、名稱',
    report17: '客戶賬號',
    report18: '會員兌換',
    report19: '會員匯款',
    report20: '會員幸運理財',
    report21: '分公司派息總額',
    report22: '交易金額',
    report23: '交易費率',
    report24: '分公司',
    report25: '暫無數據，請選擇需要查看的分公司',
    report26: '累計入金',
    report27: '充值',
    report28: '累計提現',
    report29: '搶單充值',
    report30: '提現',
    report31: '手續費盈虧',
    report32: '賬號餘額',
    report33: '提現及應付金額',
    report34: '會員入金總額',
    report35: '會員提現總額',

    report36: '會員匯款總額',
    report37: '會員幸運理財總額',
    report38: '會員兌換總額',
    report39: '會員費率盈虧總額',
    report40: '會員賬號餘額',
    report41: '會員可提現總額',

    report42: '分公司充值總額',
    report43: '分公司搶單充值總額',
    report44: '分公司費率盈虧總額',
    report45: '分公司賬號餘額',
    report46: '分公司應付現金',

    report47: '集團公司',
    report48: '商戶入金總額',
    report49: '會員及分公司盈虧總額',
    report50: '集團公司賬上餘額',

    report51: '公司賬戶額度',
    report52: '會員累計購入理財總額',
    report53: '會員累計提現總額',
    report54: '會員委託兌換總額',
    report55: '會員匯款總額',
    report56: '會員兌換匯款總額',

    report57: '會員提現提成',
    report58: '會員兌換匯款手續費總額',
    report59: '會員累計費率盈虧總額',
    report60: '理財餘額',
    report61: '賬號餘額',
    report62: '會員理財及賬號餘額',

    report63: '普通充值',
    report64: '搶單充值',
    report65: '公司累計充值總額',
    report66: '提成總額',
    report67: '派息總額',
    report68: '公司累計盈虧總額',
    report69: '操作類型',
    report70: '賬戶額度變化',
    report71: '公司提現提成',
    report72: '會員貨幣兌換',
    report73: '會員委託兌換',
    report74: '公司充值',
    report75: '收款',
    report76: '入金',
    report77: '合計',

    report78: '商戶匯款總額',
    report79: '商戶提現、委託兌換總額',
    report80: '商戶費率盈虧總額',
    report81: '分/商代理',
    report82: '代理匯款總額',
    report83: '代理提現、委託兌換總額',
    report84: '代理費率盈虧總額',
    report85: '商戶、代理及會員提現、兌換總額',
    report86: '集團公司利潤總額',

    report87: '幣種',
    report88: '入金總額',
    report89: '賬戶提現總額',
    report90: '賬戶匯款總額',
    report91: '委託方式',
    report92: '賬戶委託兌換總額',
    report93: '手續費總額',
    report94: '計息總額',
    report95: '賬號費率盈虧總額',
    report96: '理財派息',
    report97: '請輸入會員賬號',
    report98: '買入理財',
    report99: '匯款總額',
    report100: '貨幣兌換出/入',
    report101: '委託兌換總額',
    report102: '提現提成',
    report103: '處理訂單金額',
    report104: '異常值',
    report105: '正常',
    report106: '多收異常',
    report107: '少收異常',
    report108: '會員體現利潤',
    report109: '會員匯款利潤',
    report110: '會員兌換利潤',
    report111: '幸運理財提成',
    report112: '對沖貨幣理財提成',
    report113: '直播禮物利潤',
    report114: '利潤總計',

    Exchange: '兌換',
    manager: '管理端修改',
    increaseLimit: '提額',
    payorderMER_FAULT: '故障完成',
    payOrder: '提成',
    payorderthirdMER_CANCEL: '第三方派單取消',

    cooperation1: '意向合作夥伴',
    cooperation2: '合作公司',
    cooperation3: '已讀',
    cooperation4: '未讀',
    cooperation5: '提交時間',
    cooperation6: '意向合作夥伴詳情',
    cooperation7: '名',
    cooperation8: '姓',
    cooperation9: '郵箱地址',
    cooperation10: '外貿服務提供商',
    cooperation11: '年交易量',
    cooperation12: '手機號',
    cooperation13: '網站URL',
    cooperation14: '公司名稱',
    cooperation16: '職位/部門',
    cooperation17: '低於100万美元',
    cooperation18: '100万-500万美元',
    cooperation19: '500万-1000万美元',
    cooperation20: '1000万美元以上',
    cooperation21: '是',
    cooperation22: '否',
    cooperation23: '意見/投訴',
    cooperation24: '聯繫方式',

    el: {
        colorpicker: {
            confirm: '確認',
            clear: '清空'
        },
        datepicker: {
            now: '現在',
            today: '今天',
            cancel: '取消',
            clear: '清空',
            confirm: '確認',
            selectDate: '選擇日期',
            selectTime: '選擇時間',
            startDate: '開始日期',
            startTime: '開始時間',
            endDate: '結束日期',
            endTime: '結束時間',
            prevYear: '前一年',
            nextYear: '後一年',
            prevMonth: '上個月',
            nextMonth: '下個月',
            year: '年',
            month1: '1 月',
            month2: '2 月',
            month3: '3 月',
            month4: '4 月',
            month5: '5 月',
            month6: '6 月',
            month7: '7 月',
            month8: '8 月',
            month9: '9 月',
            month10: '10 月',
            month11: '11 月',
            month12: '12 月',
            // week: '周次',
            weeks: {
                sun: '日',
                mon: '一',
                tue: '二',
                wed: '三',
                thu: '四',
                fri: '五',
                sat: '六'
            },
            months: {
                jan: '一月',
                feb: '二月',
                mar: '三月',
                apr: '四月',
                may: '五月',
                jun: '六月',
                jul: '七月',
                aug: '八月',
                sep: '九月',
                oct: '十月',
                nov: '十一月',
                dec: '十二月'
            }
        },
        select: {
            loading: '加載中',
            noMatch: '無匹配資料',
            noData: '無資料',
            placeholder: '請選擇'
        },
        cascader: {
            noMatch: '無匹配資料',
            loading: '加載中',
            placeholder: '請選擇',
            noData: '無資料'
        },
        pagination: {
            goto: '前往',
            pagesize: '項/頁',
            total: '共 {total} 項',
            pageClassifier: '頁'
        },
        messagebox: {
            title: '提示',
            confirm: '確定',
            cancel: '取消',
            error: '輸入的資料不符規定!'
        },
        upload: {
            deleteTip: '按 delete 鍵可刪除',
            delete: '刪除',
            preview: '查看圖片',
            continue: '繼續上傳'
        },
        table: {
            emptyText: '暫無資料',
            confirmFilter: '篩選',
            resetFilter: '重置',
            clearFilter: '全部',
            sumText: 'Sum' // to be translated
        },
        tree: {
            emptyText: '暫無資料'
        },
        transfer: {
            noMatch: '無匹配資料',
            noData: '無資料',
            titles: ['List 1', 'List 2'], // to be translated
            filterPlaceholder: 'Enter keyword', // to be translated
            noCheckedFormat: '{total} items', // to be translated
            hasCheckedFormat: '{checked}/{total} checked' // to be translated
        },
        image: {
            error: '加載失敗'
        },
        pageHeader: {
            title: '返回'
        },
        popconfirm: {
            confirmButtonText: 'Yes', // to be translated
            cancelButtonText: 'No' // to be translated
        }
    },
    addAnget: '添加代理',
    addMerAnget: '添加商戶代理',
    addComAnget: '添加總公司',
    im1: '查詢準則不能為空',
    im2: '申請成功，請等待對方通過',
    im3: '不能發送空消息',
    im4: '添加好友',
    im5: '已申請',
    im6: '加載失敗',
    im7: '査詢',
    im8: '帳號',
    im9: '查找朋友',
    im10: '已通過',
    im11: '申請朋友',
    im12: '加載失敗',
    im13: '暫無好友',
    im14: '新的好友',
    im15: '無聊天記錄',
    im16: '[圖片]',
    im17: '[語音]',
    im18: '無連絡人',
    im19: '新的朋友',
    im20: '添加新朋友',
    im21: '蒐索記錄或帳戶名',
    im22: '申請流量額度出錯，請聯係集團公司',
    im23: '搜索',
    im24: '發起群聊',
    im25: '發送',
    im26: '請選擇需要添加的聯係人',
    im27: '群聊',
    im28: '權限不足',
    im29: '未設置流量購買費率，請聯係集團公司',
    im30: '解散該群',
    im31: '是否解散該群?',
    im32: '解散成功',

    head1: '總公司流量購買審批記錄',
    head2: '總公司累計購買流量總額',
    head3: '總公司本時段購買流量總額',
    head4: '全部總公司',
    head5: '新建總公司',
    head6: '總公司提現審批記錄',
    head7: '總公司累計提現總額',
    head8: '總公司當日提現總額',
    head9: '提現總公司帳戶',
    head10: '申請人名稱',
    head11: '總公司流量購買比例',
    head12: '用戶資訊',
    head13: '流量購入最少值為 1,000',

    //员工part2
    em1: '最近一次修改',
    em2: '修改人',
    em3: '審核',
    em4: '下級會員',
    //银行卡
    em5: '限額',
    em6: '流量控制銀行卡',
    em7: '流量控制卡',
    //流量控制
    em8: '流量購買費率',

    parentCompany: {
        firstTitle: "集團公司後台管理",
        vipError: '有會員資金異常，請立即處理',
        subCompanyNumber: '分公司數量',
        headNumber: '總公司數量',
        agentNumber: '商代數量',
        merchantNumber: '商戶數量',
        vipNumber: '會員數量',
        messageTip: 'IM消息提示',
        noMessage: '暫無消息',
        entrustRequest: '兌換請求審核',
        hasNewRequest: '您有新的用戶兌換，請審批',
        noNewRequest: '暫無兌換請求',
        merchantAccessDetail: '商戶入金流水',
        commission: '手續費',
        bonus: '提成費',
        systemRemit: '系統匯款',
        interestSum: '派息總額',
        payOrderWithdraw: '入金提現通知',
        hasNewAccessOrWithdraw: '您有新的用戶入金/提現，請審批',
        NoNewAccessOrWithdraw: '暫無入金提現請求',
        merchantDetailSum: '流水總筆數',
        weChatNumber: '微信掃碼流水',
        aliPayNumber: '支付寶掃碼流水',
        bankNumber: '銀行流水',
        cloudFlashNumber: '雲閃付流水',
        freeSumNumber: '手續費筆數',
        freeMerchantNumber: '商戶入金',
        freeRemitNumber: '匯款',
        freeEntrustNumber: '兌換',
        bonusSumNumber: '提成筆數',
        bonusWithDrawNumber: '提現提成',
        bonusRemitNumber: '匯款提成',
        bonusEntrustNumber: '兌換提成',
        bonusLuckyNumber: '新運理財',
        systemRemitNumber: '交易筆數',
        remitNumber: '匯款',
        cashEntrustNumber: '現金兌換',
        chipEntrustNumber: '掃碼兌換',
        virtualCoinNumber: '虛擬貨幣兌換',
        interestSumNumber: '派息次數',
        parentCompanyInterest: '集團公司派息',
        childCompanyInterest: '分公司派息',
        faultMessage: '故障單通知',
        faultMessageTip: '您有新的交易/匯款故障單，請處理',
        noFault: '暫無故障單',
        merchantTodayDetail: '商戶本日入金流水',
        merchantSumDetail: '總入金流水',
        companyTodayProfit: '公司本日盈利',
        sumProfit: '總盈利',
        freezeDate: '凍結數據',
        sum: '共',
        bit: '筆',
        freezeMoney: '凍結金額',
        merchantAccessRequest: '商戶提額申請',
        merchantAccessRequestTip: '您有新的商戶/高級商戶提額申請，請審批',
        noMerchantAccessRequest: '暫無商戶提額申請',
        orderMessage: '訂單消息',
        noOrder: '暫無訂單',
        orderMessageTip: '產生了一筆新的訂單，訂單號',
        IMMessageTip: '您有新的消息',
        popUpCurrName: '幣別',
        popUpAmount: '金額',
        withdrawal: '提現',

        areaCode: '地區號'

    },
    subCompany: {
        vipError: '有會員資金异常，請立即點擊處理',
        firstTitle: '公司後臺管理',
        uid: '推廣碼',
        memberNumber: '會員數量',
        liuliang: '剩餘流量',
        balance: '賬戶餘額',
        imMessageTip: 'IM消息提示',
        noImMessage: '暫無消息',
        vipEntrustRemit: '會員兌換匯款',
        vipEntrustRemitTip: '您的會員有新的兌換/匯款，請查看',
        noEntrustRemit: '暫無兌換匯款請求',
        vipWithdrawDetail: '會員提現流水',
        commission: '手續費',
        bonus: '提成費',
        vipRemitEntrust: '會員匯款兌換',
        interestSum: '派息總額',
        billAccessNotify: '搶單充值通知',
        billAccessTip: '您有新的充值訂單，請搶單',
        noBillAccess: '暫無入金提現請求',
        withdrawSum: '提現總筆數',
        weChatCode: '微信掃碼',
        aliPayCode: '支付寶掃碼',
        weChatCodeZan: '微信讚賞碼',
        personalBank: '個人銀行',
        enterBank: '企業銀行',
        cloudFlashPay: '雲閃付',
        sumNumber: '總筆數',
        vipRemit: '會員匯款',
        vipLegalEntrust: '會員貨幣兌換',
        vipCashEntrust: '會員現金兌換',
        vipChipEntrust: '會員籌碼兌換',
        vipVirtualCoin: '會員虛擬貨幣兌換',
        balanceSumNumber: '總筆數',
        balanceWeChatCode: '微信掃碼',
        balanceAliPayCode: '支付寶掃碼',
        balanceWeChatCodeZan: '微信讚賞碼',
        balancePersonalBank: '個人銀行',
        balanceEnterBank: '企業銀行',
        balanceCloudFlash: '雲閃付',
        balanceLuckyMoney: '幸運理財',
        remitSumNumber: '總筆數',
        remitVipRemit: '會員匯款',
        remitVipCashEntrust: '會員現金兌換',
        remitVipChipEntrust: '會員籌碼兌換',
        remitVipVirtualCoin: '會員虛擬貨幣兌換',
        vipTodayWithdrawDetail: '會員本日提現流水',
        sumOrderDetail: '總入金流水',
        companyToadyProfit: '公司本日盈利',
        sumProfit: '總盈利',
        faultNotify: '故障單通知',
        faultMessage: '您有新的交易/匯款故障單，請處理',
        noFault: '暫無故障單',
        vipLimitBalanceRequest: '會員提額申請',
        vipLimitBalanceMessage: '您有新的會員提額申請，請審批',
        noLimitBalance: '暫無會員提額申請',
        payOrder: '訂單消息',
        noOrder: '暫無訂單',
        orderMessageFormat: '會員（{0}）通過[{1}]提現了一筆{2}{3}的入金理財',
        faultRemitMessageFormat: '會員（{0}）有一筆匯款故障單，請處理',
        faultWithdrawMessageFormat: '會員（{0}）有一筆匯款故障單，請處理',
        imMessageContent: '您有新的消息',
        subcompany1: '分公司流量購買審批記錄',
        subcompany2: '分公司累計購買流量總額',
        subcompany3: '分公司本時段購買流量總額',
        subcompany4: '賬戶流量',
        subcompany5: '選擇購入貨幣',
        subcompany6: '請選擇購買幣種',
        subcompany7: '請加載支付資料',
        subcompany8: '匯出餘額',
        subcompany9: '分公司提現審批記錄',
        subcompany10: '分公司纍計提現總額',
        subcompany11: '分公司當日提現總額',
        subcompany12: '提現分公司賬戶',
        remitBalance: '匯出餘額',
    },
    subCompanyAgent: {
        firstTitle: '總公司後臺管理',
        agentCompanyNumber: '分公司數量',
        balance: '帳戶餘額',
        imMessageTip: 'IM消息提示',
        noMessage: '暫無消息',
        vipWithdrawDetail: '提現流水',
        commission: '手續費',
        bonus: '提成費',
        remitEntrust: '匯款兌換',
        orderSumNumber: '提現總筆數',
        orderWeChatNumber: '微信掃碼',
        orderAliPayNumber: '支付寶掃碼',
        orderWeChatCodeNumber: '微信讚賞碼',
        orderPersonBankNumber: '個人銀行',
        orderEnterBankNumber: '企業銀行',
        orderCloudFlashNumber: '雲閃付',
        freeSumNumber: '總筆數',
        freeRemitNumber: '匯款',
        freeLegalNumber: '貨幣兌換',
        freeCashNumber: '現金兌換',
        freeChipNumber: '會員籌碼兌換',
        freeVirtualCoinNumber: '虛擬貨幣兌換',
        bonusSumNumber: '總筆數',
        bonusVipOrder: '會員提現',
        bonusVipRemit: '會員匯款',
        bonusLegalEntrust: '貨幣兌換',
        bonusEntrust: '委託兌換',
        bonusLuckyMoney: '幸運理財',
        remitSumNumber: '總筆數',
        remitVipRemit: '匯款',
        remitCashRemit: '現金兌換',
        remitChipRemit: '籌碼兌換',
        remitVirtualCoinRemit: '虛擬貨幣兌換',
        todayCompanyWithdrawDetail: '本日旗下公司提現流水',
        withdrawDetail: '總提現流水',
        todayProfit: '本日盈利',
        sumProfit: '總盈利',
        payOrder: '提現訂單',
        noBill: '暫無訂單',
        orderMessageFormat: '{0}公司產生了一筆提現訂單',
        imMessageContent: '您有新的消息'
    },
    firstMerchant: {
        firstTitle: '商戶後臺管理',
        limitBalance: '帳戶額度',
        financialBalance: '理財總額',
        balance: '帳戶餘額',
        vipOrderDetail: '入金流水',
        commission: '手續費',
        remitEntrust: '匯款兌換',
        interestSum: '計息總額',
        vipOrderTotalNumber: '提現總筆數',
        vipOrderWeChatCode: '微信掃碼',
        vipOrderAliPayCode: '支付寶掃碼',
        vipOrderPersonBank: '個人銀行',
        cloudFlashNumber: '雲閃付',
        freeTotalNumber: '總筆數',
        freeAccessNumber: '理財入金',
        freeRemitNumber: '匯款',
        freeLegalNumber: '貨幣兌換',
        freeEntrustNumber: '委託兌換',
        bonusTotalNumber: '總筆數',
        bonusWeChatCode: '微信掃碼',
        bonusAliPayCode: '支付寶掃碼',
        bonusWeChatZanCode: '微信讚賞碼',
        bonusPersonBankCode: '個人銀行',
        bonusEnterBankCode: '企業銀行',
        bonusCloudFlashCode: '雲閃付',
        bonusLuckyMoneyCode: '幸運理財',
        remitTotalNumber: '總筆數',
        remitAccessNumber: '理財入金',
        remitRemitNumber: '匯款',
        remitLegalNumber: '貨幣兌換',
        remitEntrustNumber: '委託兌換',
        todayOrder: '本日入金',
        todayOrderSum: '總入金流水',
        todayFree: '本日費率',
        todayFreeSum: '總費率',
        faultNotify: '故障單通知',
        noFault: '暫無故障單',
        imMessageTitle: 'IM消息提示',
        noIMMessage: '暫無消息',
        orderMessage: '訂單消息',
        noOrder: '暫無訂單',
        imMessageContent: '您有新的消息',
        orderMessageFormat: '您有一筆通過[{0}]購買的{1}{2}的入金理財',
        remitFaultMessageFormat: '您有一筆匯款故障單，請處理',
        orderFaultMessageFormat: '您有一筆入金故障單，請處理',
    },
    firstMerchantAgent: {
        firstTitle: '商戶代理後臺管理',
        merchantNumber: '商戶數量',
        balanceNumber: '帳戶餘額',
        imMessageTitle: 'IM消息提示',
        noIMMessage: '暫無消息',
        vipOrderAccessNumber: '入金流水',
        commission: '手續費',
        bonus: '提成費',
        remitEntrust: '匯款兌換',
        vipOrderTotal: '提現總筆數',
        vipOrderWeChatCode: '微信掃碼',
        vipOrderAliPayCode: '支付寶掃碼',
        vipPersonBankCode: '個人銀行',
        vipCloudFlashCode: '雲閃付',
        freeTotalNumber: '總筆數',
        freeRemit: '匯款',
        freeRemitEntrust: '貨幣兌換',
        freeCashEntrust: '現金兌換',
        freeChipEntrust: '籌碼兌換',
        freeVirtualCoinEntrust: '虛擬貨幣兌換',
        bonusTotalNumber: '總筆數',
        bonusPayOrder: '商戶入金',
        bonusRemitNumber: '商戶匯款',
        bonusRemitLegalNumber: '商戶貨幣兌換',
        bonusEntrustNumber: '商戶委託兌換',
        bonusSumNumber: '總筆數',
        bonusRemitVipNumber: '匯款',
        bonusEntrustLegalNumber: '貨幣兌換',
        bonusCashLegalNumber: '現金兌換',
        bonusChipLegalNumber: '籌碼兌換',
        bonusVirtualCoinNumber: '虛擬貨幣兌換',
        todayMerchantAccessDetail: '本日旗下商戶入金流水',
        sumAccessDetail: '總入金流水',
        todayProfit: '本日盈利',
        sumProfit: '總盈利',
        orderMessage: '訂單消息',
        noOrder: '暫無訂單',
        orderVVIPMessageFormat: "{0} 高級會員產生了一筆入金訂單",
        orderMerchantMessageFormat: "{0} 商戶產生了一筆入金訂單",
        imMessageContent: '您有新的消息',
        faultRemitMessageFormat: '您有一筆匯款故障單，請處理',
        faultOrderMessageFormat: '您有一筆入金故障單，請處理',
    },
    agentCustomerStatisticsReport: {
        customerName: '客戶名',
        sumNumber: '筆數',
        money: '金額'
    },
    chat1: '新建群聊',
    chat2: '完成',
    chat3: '選擇群組',
    chat4: '選擇群聊',
    chat5: '群聊資訊',
    chat6: '群聊名稱',
    chat7: '清空聊天記錄',
    chat8: '刪除並退出',
    chat9: '群名修改',
    chat10: '請輸入群聊名稱',
    chat11: '用戶賬號',
    chat12: '朋友圈',
    chat13: '添加到通訊錄',
    chat14: '選擇成員',
    chat15: '暫無好友可以添加',
    chat16: '是否刪除並退出?',
    chat17: '已將',
    chat18: '移出群聊',
    chat19: '你已將',
    chat20: '邀請',
    chat21: '加入群聊',
    chat22: '你邀請',
    chat23: '退出群聊',
    chat24: '你已被移出群聊',
    chat25: '你',
    chat26: '修改群昵稱為',
    chat27: '聊天',
    chat28: '通訊錄',
    chat29: '發消息',
    chat30: '用戶賬號',
    chat31: '進入群聊',
    chat32: '群聊名稱',
    chat33: '你們已經是好友了，快來一起聊天吧',
    chat34: '點擊添加備注',
    chat35: '備注',
    chat36: '設置備注失敗，請重新設置',

    paypal1: 'Paypal賬號',
    paypal2: 'Paypal郵箱',
    paypal3: 'Paypal二維碼',
    paypal4: '請輸入Paypal賬號',
    paypal5: '請輸入Paypal郵箱',
    paypal6: '請選擇Paypal二維碼',
    paypal7: 'PayPal支付',

    theChannel: {
        channel1: '通道類型',
        channel2: '支付類型',
        channel3: '通道圖標',
        channel4: '新建通道',
        channel5: '手續費最小值',
        channel6: '提成最小值',
        channel7: '適用群體',
        channel8: '最大率',
        channel9: '通道類型(英文)',
        channel10: '通道類型(繁體)',
        channel11: '通道類型(日文)',
        channel12: '通道類型(韓文)',
        channel13: '圖標大小不能超過2kb',
        channel14: '請將通道信息補充完整',
        channel15: '手續費最小值不能大於最大率',
        channel16: '提成最小值不能大於最大率',
        channel17: '修改通道信息',
        channel18: '修改通道狀態失敗',
        channel19: '修改通道状态成功',
        channel20: '步進值',
        channel21: '最大率不能小於0',
        channel22: '手續費最小值不能小於0',
        channel23: '提成最小值不能小於0',
        channel24: '步進值不能小於0',
        channel25: '請輸入通道名稱',
    },
    present: {
        presentName: '禮物名稱',
        presentImage: '禮物圖片',
        presentCurrency: '禮物幣別',
        presentCost: '禮物價格',
        enterPresentName: '請輸入禮物名稱',
        newPresent: '新建禮物',
        presentEn: '禮物名稱(英語)',
        presentTr: '禮物名稱(繁體)',
        presentJa: '禮物名稱(日語)',
        presentKr: '禮物名稱(韓語)',
        editPresent: '修改禮物信息',
        completeInfo: '請將禮物信息補充完整',
        limit: '圖片大小不能超過',
        AmoutErr: '禮物價格不能為負數',
    },
    anchorCom: {
        anchorCompany: '直播公司',
        number: '公司個數',
        most: '招募主播最多',
        highest: '直播收入最高',
        name: '公司名稱',
        anchors: '旗下主播',
        living: '直播中',
        giftAmount: '禮物總額',
        new: '新建直播公司',
        companyStatus: '公司狀態',
        enterName: '請輸入公司名稱',
        account: '公司賬號',
        companyName: '公司名稱',
        edit: '修改直播公司資料',
        returnsRate: '收益提成率',
        flowRecord: '流量購買審批記錄',
        flowTotal: '纍計購買流量總額',
        flowCurTot: '本時段購買流量總額',
        withdrawalRecord: '直播公司提現審批記錄',
        withdrawalTotal: '直播公司纍計提現總額',
        withdrawalCurTot: '直播公司本時段提現總額',
        anchorsNum: '主播數量',
        homeTitle: '直播公司後臺管理',
        mustAccount: '直播公司賬號不能爲空',
        mustName: '直播公司名稱不能為空',
        digital1: '公司數字貨幣充值記錄',
        digital2: '公司累計充值總額',
        digital3: '公司當天充值總額',
    },
    zhubo: {
        anchor: '主播',
        numofLiving: '直播中個數',
        mostGifted: '禮物收取最高',
        anchorStatu: '用户状态',
        followers: '粉絲總數',
        new: '新建主播',
        type: '主播類型',
        liveAnchor: '直播主播',
        interactionAnchor: '互動主播',
        account: '主播賬號',
        name: '主播名稱',
        plsSelectType: '請選擇主播類型',
        flowRecord: '主播流量购买审批记录',
        flowTotal: '主播累计购买流量总额',
        flowCurTot: '主播本时段购买流量总额',
        enterName: '請輸入主播名稱',
        edit: '修改主播資料',
        rate: '主播費率',
        plsEnterAct: '主播賬號不能爲空',
        plsEnterName: '主播名稱不能爲空',
        maximumRecharge: '充值單筆最大',
        rechargeCharge: '充值手續費',
        fansNum: '粉絲數量',
        toTop: '置頂',
        fanschange: '粉絲數修改',
        plsFans: '請輸入粉絲數量',
        changeFans: '是否修改該主播的粉絲數量?',
        topAnchor: '是否置頂該主播?',
        unTopAnchor: '是否取消置頂該主播?',
    },
    giftRecord1: '禮物消費總額',
    giftRecord2: '消費最高會員',
    giftRecord3: '禮物類型',
    giftRecord4: '禮物數量',
    giftRecord5: '收禮主播',
    giftRecord6: '請輸入會員名稱或訂單號',
    giftRecord7: '交易類型',
    giftRecord8: '打賞主播',
    giftRecord9: '禮物消費',


    anchorCompany: '直播公司',
    sexAnchor: '互動主播',
    liveAnchor: '直播主播',

    merchantAgent1: '商代流量購買審批記錄',
    merchantAgent2: '商代纍計購買流量總額',
    merchantAgent3: '商代本時段購買流量總額',
    merchantAgent4: '商代賬號',
    merchantAgent5: '請輸入商代名稱',

    digital1: '數字貨幣充值記錄',
    digital2: '纍計充值總額',
    digital3: '當天充值總額',
    digital4: '數字貨幣充值',
    digital5: '充值數字貨幣',
    digital6: '數字貨幣金額',
    digital7: '充值貨幣',
    digital8: '數字貨幣金額',
    digital9: '選擇數字貨幣',
    digital10: '鏈名稱通道',
    digital11: '數字貨幣名稱',
    digital12: '交易平臺',
    digital13: '收款錢包地址',
    digital14: '轉賬數量',
    digital15: '收款二維碼',
    digital16: '數字貨幣充值詳情',
    digital17: '請選擇數字貨幣',
    digital18: '請選擇充值貨幣',
    digital19: '充值成功',
    digital20: '請輸入正確的匯率',
    digital21: '數字貨幣充值收款通道',

    shortVideo1: '播放次數',
    shortVideo2: '點贊數量',
    shortVideo3: '評論數量',
    shortVideo4: '分享次數',
    shortVideo5: '上傳時間',
    shortVideo6: '查看視頻',
    shortVideo7: '置頂',
    shortVideo8: '取消置頂',
    shortVideo9: '編輯視頻資料',
    shortVideo10: '在綫短視頻數量',
    shortVideo11: '請將短視頻信息補充完整',
    shortVideo12: '播放次數必須大於等於0次',
    shortVideo13: '點贊數量必須大於等於0次',
    shortVideo14: '評論數量必須大於等於0次',
    shortVideo15: '分享次數必須大於等於0次',
    shortVideo16: '短視頻預覽',
    shortVideo17: '點擊查看視頻',

    livingRoom1: '直播房間數',
    livingRoom2: '房間號',
    livingRoom3: '觀看人數',
    livingRoom4: '直播禮物',
    livingRoom5: '請輸入用戶名稱/賬號',
    livingRoom6: '請輸入房間號',
    livingRoom7: '强制下播',
    livingRoom8: '確定强制下播該房間？',
    livingRoom9: '修改觀看人數',
    livingRoom10: '觀看人數不能為負數',
    livingRoom11: '觀看人數不能為空',
    ad: {
        addAd: '新增廣告',
        adTitle: '廣告標題',
        adUrl: '廣告圖片',
        jumpUrl: '跳轉鏈接',
        adUrlTip: '請上傳廣告圖片',
        adCountTip: '廣告條數已經用完，請刪除再創建',
        isdeleAd: '是否刪除這條廣告',
        updateAdTitle: '修改廣告',
    },
    notification: {
        addNotificationTitle: '新建公告',
        updateNotificationTitle: '修改公告',
        notificationContent: '公告內容',
        notificationTitle: '公告標題',
        tip: '請輸入公告標題/公告內容',
        isDelectNotification: '是否刪除這條公告'
    },
    userManage: {
        userManage1: '會員個數',
        userManage2: '推廣最多',
        userManage3: '普通會員',
        userManage4: '平台交易員',
        userManage5: 'OTC交易員',
        userManage6: '待審核',
        userManage7: '已審核',
        userManage8: '申請升級',
        userManage9: '推廣人數',
        userManage10: '交易員審核',
        userManage11: '會員填寫信息',
        userManage12: '系統讀取信息',
        userManage13: '真實姓名',
        userManage14: '所在國家',
        userManage15: '主要交易貨幣',
        userManage16: '用戶主貨幣',
        userManage17: '所在州/省',
        userManage18: '所在城市',
        userManage19: '驗證碼手機號碼',
        userManage20: '系統讀取國家',
        userManage21: '系統讀取州/省',
        userManage22: '系統讀取城市',
        userManage23: '服務費',
        userManage24: '定額賬號充值',
        userManage25: '現金交易充值',
        userManage26: '法定貨幣提現',
        userManage27: '現金交易手續費',
        userManage28: '轉賬匯款手續費',
        userManage29: '貨幣兌換手續費',
        userManage30: '轉賬匯款服務費',
        userManage31: '通道餘額',
        userManage32: '通道限額',
        userManage33: '空閒',
        userManage34: '交易中',
    },
    order: {
        status: {
            ROBBING: '待接单',
            WAIT_REMIT: '等待转账',
            WAIT_PAY: '等待支付',
            WAIT_CONFIRM: '等待确认',
            PENDING: '等待审核',
            SUCCESS: '订单完成',
            REJECTED: '驳回',
            CANCEL: '已取消'
        }
    }
}
